import React, { FC } from 'react';
import { TableCell, Typography } from '@material-ui/core';

import { Numeric } from 'components';

interface IProps {
  value: number;
}

const StatCell: FC<IProps> = ({ value }) => (
  <TableCell size="small" align="center">
    <Typography variant="subtitle2">
      <Numeric value={value} />
    </Typography>
  </TableCell>
);

export default StatCell;
